<template>
    <b-modal
      title="Dados do cliente"
      no-close-on-backdrop
      size="xl"
      ok-only
      centered
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
      <b-row class="mt-2">
       <b-col cols="12" class="mt-3">
        <b-laber>Nome: </b-laber>
        <b-input v-model="dataClient.name" disabled class="mt-1" />
       </b-col>

       <b-col cols="12" class="mt-3">
        <b-laber>Email: </b-laber>
        <b-input v-model="dataClient.email" disabled class="mt-1" />
       </b-col>

       <b-col cols="12" class="mt-3">
        <b-laber>Cep: </b-laber>
        <b-input 
          v-model="dataClient.cep" 
          disabled 
          class="mt-1" 
          v-mask="'#####-###'"
        />
       </b-col>

       <b-col cols="12" class="mt-3">
        <b-laber>Endereço: </b-laber>
        <b-input v-model="dataClient.address" disabled class="mt-1" />
       </b-col>

       <b-col cols="12" class="mt-3">
        <b-laber>Telefone: </b-laber>
        <b-input 
          v-model="dataClient.telephone" 
          v-mask="['(##) #####-####', '(##) ####-####']"
          disabled 
          class="mt-1" 
        />
       </b-col>

       <b-col cols="12" class="mt-3">
        <b-laber>CPF: </b-laber>
        <b-input  v-model="dataClient.cpf" disabled class="mt-1" v-mask="'###.###.###-##'" />
       </b-col>

       <b-col cols="12" class="mt-3">
        <b-laber>Cadastrou-se em: </b-laber>
        <b-input v-model="dataClient.createdAt" disabled class="mt-1" />
       </b-col>
      </b-row>
    </b-modal>
</template>
<script>



export default {
  name: 'VideoManual',
  
  data() {
    return {
      loading: false,
      open: false,
      dataClient: [],
    };
  },

  methods: {
    toggleOpen({data = []}) {
      this.open = !this.open;
      this.dataClient = data
    },
  },
};
</script>
<style></style>
